<template>
  <div class="home-container">
    <div class="hx-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>年夜饭预定管理</el-breadcrumb-item>
        <el-breadcrumb-item>餐厅管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="hx-form-container box-shadow">
      <el-form ref="listForm" :model="listParams" label-width="120px" inline>
        <el-form-item label="餐厅名称：" prop="name">
          <el-input style="width: 300px" v-model="listParams.name" placeholder="请填写餐厅名称" />
        </el-form-item>

        <el-form-item label="">
          <el-button @click="loadTableData(true)" type="primary">查询</el-button>
        </el-form-item>
      </el-form>

      <hx-table-result :page-info="pager" :loading="tableLoading" @page-current-change="handleCurrentChange" @page-size-change="handleSizeChange">
        <div slot="action"></div>

        <hx-table-result-col>
          <div class="wrap-table-info-display">
            <el-button @click="openDialog('')" type="primary">新增</el-button>
            <span class="table-info-display">
              <span>总条数：</span>
              <span class="alert-text ft16">{{ pager.total }}</span>
            </span>
          </div>
        </hx-table-result-col>

        <el-table slot="content" :data="tableData" max-height="600" border>
          <icTableColumnIndex :pageIndex="pager.pageIndex" :pageSize="pager.pageSize" />

          <el-table-column label="餐厅名称" prop="name" align="center"></el-table-column>
          <el-table-column label="操作" prop="" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="addDishRoom(scope.row)">包间管理</el-button>
              <el-button type="text" @click="editItem(scope.row.id)">编辑餐厅</el-button>
              <confirm-button type="text" style="margin: 0 10px" title="确认要删除该餐厅吗？" @confirmed="deleteItem(scope.row.id)">
                <span>删除</span>
              </confirm-button>
            </template>
          </el-table-column>
        </el-table>
      </hx-table-result>
    </div>

    <el-dialog title="餐厅管理" :visible.sync="dialogVisible" @close="$refs['dialogForm'].resetFields()" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form ref="dialogForm" :model="dialogForm" :rules="dialogRules" label-width="140px">
        <el-form-item label="餐厅名称：" prop="name">
          <el-input v-model="dialogForm.name" placeholder="请填写餐厅名称" maxlength="10" show-word-limit />
        </el-form-item>
        <el-form-item label="餐厅地址：" prop="address">
          <el-input v-model="dialogForm.address" placeholder="请填写餐厅地址" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="餐厅电话：" prop="mobile">
          <el-input v-model="dialogForm.mobile" placeholder="请填写餐厅联系电话，用于接收预约短信" :maxlength="11" show-word-limit />
        </el-form-item>
        <el-form-item label="管理员手机号：" prop="appManageMobileList">
          <el-button type="primary" size="small" @click="handleAppendPhone">添加</el-button>
          <div class="itemRow" v-for="(item, index) in dialogForm.appManageMobileList" :key="index">
            <el-input v-model="dialogForm.appManageMobileList[index]" placeholder="请填写" class="w200" size="small" :maxlength="11" />
            <el-button type="danger" class="mgl10" size="small" @click="handleRemovePhone(index)">删除</el-button>
          </div>
        </el-form-item>
        <el-form-item label="餐厅主图：" prop="picture">
          <oss-uploader @setImage="getImage" :previewList="previewList"></oss-uploader>
        </el-form-item>
        <el-form-item label="" style="text-align: center">
          <el-button @click="dialogVisible = false">取消</el-button>
          <el-button @click="saveDialog('dialogForm')" type="primary" :disabled="isDisabled">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    const checkMobileRule = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请填写餐厅联系电话"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("电话格式不正确，请重新填写"));
      } else {
        callback();
      }
    };
    return {
      listParams: {
        name: "",
      },
      pager: {
        pageIndex: 1,
        pageSize: 15,
        total: 0,
      },
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogForm: {
        name: "",
        address: "",
        mobile: "",
        picture: "",
        appManageMobileList: [],
      },
      dialogRules: {
        name: [{ required: true, message: "请填写餐厅名称", trigger: "blur" }],
        address: [{ required: true, message: "请填写餐厅地址", trigger: "blur" }],
        mobile: [
          { required: true, message: "请填写餐厅联系电话", trigger: "blur" },
          { validator: checkMobileRule, trigger: "blur" },
        ],
      },
      method: "",
      isDisabled: false,
      previewList: [],
    };
  },

  mounted() {
    this.loadTableData();
  },

  methods: {
    /**
     * @description: 加载列表
     * @param {*} isReset
     * @return {*}
     */
    loadTableData(isReset) {
      if (isReset) {
        this.pager.pageIndex = 1;
      }
      this.tableLoading = true;
      const bodyParams = Object.assign(this.listParams, this.pager);
      this.$http({
        url: global.apiUrl + "/canteen",
        method: "GET",
        params: bodyParams,
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.tableLoading = false;
            this.tableData = res.body.data.data;
            this.pager.total = res.body.data.total;
          } else {
            this.tableLoading = false;
          }
        })
        .catch(err => {
          this.tableLoading = false;
          console.error(err);
        });
    },
    /**
     * pageIndex的change事件
     * @param val
     */
    handleCurrentChange(val) {
      this.pager.pageIndex = val;
      this.loadTableData();
    },
    /**
     * pageSize的change事件
     * @param val
     */
    handleSizeChange(val) {
      this.pager.pageSize = val;
      this.loadTableData();
    },
    /**
     * @description: 新增包间
     * @param {*} row
     * @return {*}
     */
    addDishRoom(row) {
      this.$router.push({
        name: "addDishroomManagement",
        query: {
          name: row.name,
          id: row.id,
        },
      });
    },
    /**
     * @description: 编辑餐厅
     * @param {*} id
     * @return {*}
     */
    editItem(id) {
      this.$http({
        url: global.apiUrl + "/canteen/detail",
        method: "GET",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            Object.assign(this.dialogForm, res.body.data);
            if (this.dialogForm.picture) {
              this.previewList = [this.dialogForm.picture];
            }
            this.openDialog(id);
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 删除餐厅
     * @param {*} id
     * @return {*}
     */
    deleteItem(id) {
      this.$http({
        url: global.apiUrl + "/canteen",
        method: "DELETE",
        params: { id },
      })
        .then(res => {
          if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
            this.$message.success(res.body.info);
            this.loadTableData();
          } else {
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    /**
     * @description: 打开弹框
     * @param {*} id
     * @return {*}
     */
    openDialog(id) {
      if (id) {
        this.method = "PUT";
      } else {
        //* 还原表单
        this.dialogForm = this.$options.data().dialogForm;
        this.previewList = [];
        this.method = "POST";
      }
      this.dialogVisible = true;
    },
    /**
     * @description: 获取上传的图片
     * @param {*} file
     * @return {*}
     */
    getImage(file) {
      this.dialogForm.picture = file;
    },

    /**
     * 添加手机号
     */
    handleAppendPhone() {
      this.dialogForm.appManageMobileList.push("");
    },
    handleRemovePhone(index) {
      this.dialogForm.appManageMobileList.splice(index, 1);
    },
    /**
     * @description: 保存表单
     * @param {*} name
     * @return {*}
     */
    saveDialog(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const bodyParams = Object.assign(this.dialogForm);
          if (!bodyParams.appManageMobileList || bodyParams.appManageMobileList.length == 0) {
            this.$message.warning("请添加管理员手机号");
            return;
          }
          const fullInput = bodyParams.appManageMobileList.every(item => !!item);
          if (!fullInput) {
            this.$message.warning("请完善管理员手机号");
            return;
          }
          this.isDisabled = true;
          this.$http({
            url: global.apiUrl + "/canteen",
            method: this.method,
            body: bodyParams,
          })
            .then(res => {
              this.isDisabled = false;
              if (res.body.apiStatus === 0 && res.body.sysStatus === 0) {
                this.$message.success(res.body.info);
                this.dialogVisible = false;
                //* 还原表单
                this.dialogForm = this.$options.data().dialogForm;
                this.previewList = [];
                this.loadTableData();
              } else {
              }
            })
            .catch(err => {
              this.isDisabled = false;
              console.error(err);
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.itemRow {
  margin-top: 5px;
}
</style>
